import React, { useState } from 'react';
import { useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button,
} from 'reactstrap';
import ReactImageFallback from 'react-image-fallback';
import {
  LOGO_LARGE_BLACK, FALLBACK_ICON, staticConstants, capitalizeEveryWord, handleGraphqlError,
} from '../../utils';
import { UPDATE_STATUS, LOADER_MUTATION } from '../../graphql-client/mutations';

function Deactivate(props) {
  const { addToast } = useToasts();
  const {
    isOpen, onClose, userDetail, role, updateUserList,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const isAccountDeactivated = userDetail.status === staticConstants.STATUS_TYPE.DEACTIVATED;
  let fetchedProfileImage;

  /* ---- Change update status mutation ----*/

  const [loader] = useMutation(LOADER_MUTATION, {
    variables: { show: false },
  });
  const [deactivateUserAccount] = useMutation(UPDATE_STATUS, {
    variables: {},
    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted(data) {
      loader({ variables: { show: false } });
      addToast(data.updateStatus.message, { appearance: 'success' });
      updateUserList && updateUserList();
      onClose();
    },

  });
  /* ---- end update status mutation ----*/

  const actionOnArtistAccount = () => {
    const reqObj = {
      userId: userDetail._id,
      status: isAccountDeactivated
        ? staticConstants.STATUS_TYPE.ACTIVE : staticConstants.STATUS_TYPE.DEACTIVATED,
    };
    loader({ variables: { show: true } });
    deactivateUserAccount({ variables: reqObj });
  };

  const hideModal = () => {
    toggle();
    onClose();
  };

  if (role === staticConstants.ROLE_TYPE.ARTIST) {
    fetchedProfileImage = userDetail && userDetail.artistImage !== ''
      ? userDetail.artistImage : LOGO_LARGE_BLACK;
  } else {
    fetchedProfileImage = userDetail && userDetail.managerImage !== ''
      ? userDetail.managerImage : LOGO_LARGE_BLACK;
  }
  return (
    <Modal isOpen={(modal && userDetail) && modal} className="modal-deactivate modal-dialog-centered">
      <ModalBody>
        <h2>
          Are you sure you want to
          {' '}
          {isAccountDeactivated ? 'activate' : 'deactivate' }
          {' '}
          this account?
        </h2>
        <p>
          Following User will
          {' '}
          {isAccountDeactivated ? 'be' : 'not be' }
          {' '}
          able to login.
        </p>
        <div className="deactivate-user">
          <span>
            <ReactImageFallback
              src={fetchedProfileImage}
              fallbackImage={FALLBACK_ICON}
              className="image-cover"
              alt="User"
            />
          </span>
          <div className="deactivate-user-info">
            <h4>
              {
              role === staticConstants.ROLE_TYPE.MANAGER
                ? capitalizeEveryWord(`${userDetail.managerFirstName} ${userDetail.managerLastName}`)
                : capitalizeEveryWord(`${userDetail.name}`)
              }
            </h4>
            <p>{role}</p>
          </div>
        </div>
        <div className="deactivate-modal-footer">
          <span onClick={hideModal}>Cancel</span>
          <Button
            type="button"
            color={`${isAccountDeactivated ? 'activate' : 'deactivate'}`}
            onClick={() => { actionOnArtistAccount(); }}
          >
            {isAccountDeactivated ? 'Activate account' : 'Deactivate account'}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

Deactivate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userDetail: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  updateUserList: PropTypes.func,
};

Deactivate.defaultProps = {
  updateUserList: null,
};

export default Deactivate;
